"use client";
import Cleave from "cleave.js/react";
import { ReactInstanceWithCleave } from "cleave.js/react/props";
import { forwardRef, useEffect, useRef, useState } from "react";
import TextField from "../TextField";
import { TextFieldProps } from "../TextField/types";

export type NumberFieldProps = {
  format?: boolean;
  germanLocale?: boolean;
} & TextFieldProps;

const NumberField = forwardRef<NumberFieldProps, any>(function NumberField(
  { onChange, value, format = true, germanLocale = true, ...props },
  ref,
) {
  const numeralDecimalMark = germanLocale ? "," : ".";
  const delimiter = germanLocale ? "." : ",";
  const isDecimalMark = useRef(false);
  const [cleave, setCleave] = useState<ReactInstanceWithCleave>();

  const handleChange = (event: any) => {
    const number = event.target.rawValue ? Number(event.target.rawValue) : null;
    isDecimalMark.current = event.target.value.endsWith(numeralDecimalMark);
    onChange?.(number);
  };

  useEffect(() => {
    let rawValue = isNaN(value) ? "" : String(value);
    if (isDecimalMark.current) {
      rawValue += numeralDecimalMark;
    }
    cleave?.setRawValue(rawValue);
  }, [value, isDecimalMark, cleave, numeralDecimalMark]);

  return (
    <TextField
      {...props}
      htmlRef={ref}
      // @ts-expect-error TODO: replace cleave.js (deprecated) by new library cleave-zen
      as={Cleave}
      value="0"
      onInit={setCleave}
      options={{
        numeralDecimalMark: numeralDecimalMark,
        delimiter: format ? delimiter : "",
        numeral: true,
      }}
      onChange={handleChange}
    />
  );
});

export default NumberField;
